/* SLOH — theme behaviour. No dependencies, no build step. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── mobile nav ─────────────────────────────────────────── */
  function initNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('[data-nav-main]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = nav.getAttribute('data-open') === 'true';
      nav.setAttribute('data-open', String(!open));
      toggle.setAttribute('aria-expanded', String(!open));
      toggle.textContent = open ? 'Menu' : 'Close';
    });
  }

  /* ── the snap demo (hero signature) ─────────────────────── */
  function initSnapDemo() {
    var rig = document.querySelector('[data-rig]');
    if (!rig) return;
    var root = rig.closest('[data-snap-demo]') || document;
    var bL = root.querySelector('[data-snap="loose"]');
    var bS = root.querySelector('[data-snap="snapped"]');
    var note = root.querySelector('[data-demo-note]');
    if (!bL || !bS) return;

    var looseText = note ? note.getAttribute('data-loose') : '';
    var snapText = note ? note.getAttribute('data-snapped') : '';

    function set(state) {
      rig.dataset.state = state;
      var snapped = state === 'snapped';
      bS.setAttribute('aria-pressed', String(snapped));
      bL.setAttribute('aria-pressed', String(!snapped));
      if (note) note.textContent = snapped ? snapText : looseText;
    }

    bL.addEventListener('click', function () { set('loose'); });
    bS.addEventListener('click', function () { set('snapped'); });

    // Show the problem first, then resolve it — the page makes its own argument.
    if (!reduce) {
      set('loose');
      setTimeout(function () { set('snapped'); }, 1400);
    } else {
      set('snapped');
    }
  }

  /* ── product gallery ────────────────────────────────────── */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          main.src = thumb.getAttribute('data-src');
          main.srcset = thumb.getAttribute('data-srcset') || '';
          main.alt = thumb.getAttribute('data-alt') || '';
          thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
          thumb.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* ── variant picker ─────────────────────────────────────── */
  function initVariantPicker() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var form = picker.closest('form');
      if (!form) return;
      var dataEl = picker.querySelector('[data-variant-json]');
      if (!dataEl) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var idInput = form.querySelector('[data-variant-id]');
      var priceEl = form.querySelector('[data-price]');
      var comparEl = form.querySelector('[data-compare-price]');
      var submit = form.querySelector('[data-add-button]');
      var moneyFormat = picker.getAttribute('data-money-format') || '£{{amount}}';
      var soldOutLabel = picker.getAttribute('data-sold-out') || 'Sold out';
      var addLabel = picker.getAttribute('data-add-label') || 'Add to bag';
      var unavailable = picker.getAttribute('data-unavailable') || 'Unavailable';

      function money(cents) {
        var value = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value);
      }

      function selectedOptions() {
        return Array.prototype.map.call(
          picker.querySelectorAll('[data-option-index]'),
          function (group) {
            var checked = group.querySelector('input:checked');
            return checked ? checked.value : null;
          }
        );
      }

      function update() {
        var chosen = selectedOptions();
        var match = variants.filter(function (v) {
          return chosen.every(function (opt, i) { return opt === null || v.options[i] === opt; });
        })[0];

        if (!match) {
          if (submit) { submit.setAttribute('aria-disabled', 'true'); submit.textContent = unavailable; }
          return;
        }

        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (comparEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            comparEl.textContent = money(match.compare_at_price);
            comparEl.hidden = false;
          } else {
            comparEl.hidden = true;
          }
        }
        if (submit) {
          if (match.available) {
            submit.removeAttribute('aria-disabled');
            submit.textContent = addLabel;
          } else {
            submit.setAttribute('aria-disabled', 'true');
            submit.textContent = soldOutLabel;
          }
        }

        // Keep the URL shareable without a reload.
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      picker.addEventListener('change', update);
      update();
    });
  }

  /* ── quantity steppers ──────────────────────────────────── */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (widget) {
      var input = widget.querySelector('input');
      if (!input) return;
      widget.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10);
          var min = parseInt(input.getAttribute('min') || '1', 10);
          var next = (parseInt(input.value, 10) || min) + step;
          input.value = String(Math.max(min, next));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ── cart line quantity + remove (no page reload) ───────── */
  function initCartUpdates() {
    var cart = document.querySelector('[data-cart]');
    if (!cart) return;

    function change(line, quantity) {
      cart.setAttribute('aria-busy', 'true');
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });
    }

    cart.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-cart-remove]');
      if (remove) {
        e.preventDefault();
        change(parseInt(remove.getAttribute('data-cart-remove'), 10), 0);
      }
    });

    cart.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty]');
      if (input) {
        change(parseInt(input.getAttribute('data-cart-qty'), 10), parseInt(input.value, 10) || 0);
      }
    });
  }

  /* ── collection sort ────────────────────────────────────── */
  function initSort() {
    var sort = document.querySelector('[data-sort]');
    if (!sort) return;
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ── header cart count, kept fresh after ajax adds ──────── */
  function refreshCartCount() {
    var el = document.querySelector('[data-cart-count]');
    if (!el) return;
    fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      })
      .catch(function () {});
  }

  function init() {
    if (!window.Shopify) window.Shopify = {};
    if (!window.Shopify.routes) window.Shopify.routes = { root: '/' };
    initNav();
    initSnapDemo();
    initGallery();
    initVariantPicker();
    initQty();
    initCartUpdates();
    initSort();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.SLOH = { refreshCartCount: refreshCartCount };
})();
